export const SET_BUCKET_ITEMS = 'SET_BUCKET_ITEMS'
export const SET_ITEM = 'SET_ITEM'
export const SET_QUESTION = 'SET_QUESTION'
export const SET_SPECIAL_REQUESTS = 'SET_SPECIAL_REQUESTS'
export const REMOVE_ITEM = 'REMOVE_ITEM'
export const RESET_BUCKET = 'RESET_BUCKET'
export const RESET_ALL_BUCKETS = 'RESET_ALL_BUCKETS'
